import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import {Spinner, Stack } from 'react-bootstrap'

interface Props {
    data?: any
    reload : boolean
    heading : any
    subheading : any
    top?: any
    classname? : any
  }

const ConversionRateCard = ({data, reload, heading, subheading, top, classname}:Props) => {
    const [series, setSeries] = useState<any>([])

    useEffect(()=>{
      if(data !== undefined) { 
        setSeries(Math.round(data?.conversionRate)) 
    }
    },[data?.conversionRate])
    
    const optionsConservationRate: Object = {
        chart: {
            fontFamily: 'Inter',
            height: 380,
            type: 'radialBar'
        },
        colors: ['#009EF6'],
        plotOptions: {
            radialBar: {
                show : true,
                range: ['0%', '100%'],
                hollow: {
                    margin: 0,
                    size: '67%',
                  },
                startAngle: -90,
                endAngle: 90,
                track: {
                    show : true,
                    background: '#EEF6FF',
                    startAngle: -90,
                    endAngle: 90,
                    strokeWidth: '100%',
                },
                dataLabels: {
                    show : true,
                    value: {
                        fontSize: '30px',
                        fontWeight : '700',
                        offsetY: -43,
                    }, 
                    name: {
                        offsetY: -5,
                        color: '#A1A5B7',
                        fontSize: '13px',
                        fontWeight: '500',
                    }, 
                },
            },
        },
        stroke: {
            lineCap: 'round'
        },
        labels: ['Conversion'],
    }

    return (
        <div className='card card-flush card-border mb-5' style={{minHeight:'365px'}}>
            <Stack gap={2} className='container mt-8 ms-4'>
                <div className='text-dark fw-bolder fs-3'>{heading}</div>
                <Stack direction='horizontal' gap={2}>
                    {/* <div className='fw-bold fs-6 text-dark'>{data?.totalTpvs}</div>
                    <div className='text-muted fs-6'>{subheading}</div> */}
                </Stack>
            </Stack>
            {reload ? (
                <div className="text-center align-items-center mb-20">
                <Spinner animation="border" className="text-gray-600 text-center" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>) : (
            <div className='container mb-16'>
                <div className='position-relative d-flex flex-center' id="salesChart">
                    <Chart
                        type='radialBar'
                        width={330}
                        height={310}
                        series={[series]}
                        options={optionsConservationRate}
                        className='d-block'
                    />
                    <div className={`d-flex text-muted ${classname}`} style={{position:'absolute',marginTop:top}}>
                        <div style={{marginLeft:'-160%'}}>0%</div>
                        <div style={{marginLeft:'350%'}}>100%</div>
                    </div>
                </div>
                
            </div>
            )}
        </div>
    )
}

export default ConversionRateCard
